import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../../../assets/css/Ngo/controlpanelCSS/NgoAuth.css';
import '../../../assets/css/Ngo/controlpanelCSS/ForgetPassword.css';

function ForgotPasswordModal({ onClose }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleRecover = async () => {
        if (!email.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Email Required',
                text: 'Please enter your email address.',
                confirmButtonColor: '#4361ee',
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Email',
                text: 'Please enter a valid email address.',
                confirmButtonColor: '#4361ee',
            });
            return;
        }

        setLoading(true);
        await new Promise((res) => setTimeout(res, 1200));
        setLoading(false);
        onClose();

        Swal.fire({
            icon: 'success',
            title: 'Email Sent!',
            html: `Password reset link has been sent to <br/><strong>${email}</strong><br/>Please check your inbox.`,
            confirmButtonText: 'OK, Got it!',
            confirmButtonColor: '#4361ee',
            timer: 6000,
            timerProgressBar: true,
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
        });
    };

    return (
        <div className="fp-modal-overlay" onClick={onClose}>
            <div className="fp-modal-box" onClick={(e) => e.stopPropagation()}>
                <button className="fp-modal-close" onClick={onClose}>✕</button>

                <div className="fp-modal-icon">
                    <svg viewBox="0 0 24 24">
                        <rect x="2" y="4" width="20" height="16" rx="2" />
                        <path d="M2 7l10 7 10-7" />
                    </svg>
                </div>

                <h2 className="fp-modal-title">Forgot Password?</h2>
                <p className="fp-modal-subtitle">
                    Enter your registered email and we'll send you a password reset link.
                </p>

                <label className="fp-modal-label">Email Address</label>
                <input
                    className="fp-modal-input"
                    type="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleRecover()}
                    autoFocus
                />

                <button
                    className="fp-modal-btn"
                    onClick={handleRecover}
                    disabled={loading}
                >
                    {loading ? 'Sending...' : 'Recover Password'}
                </button>

                <button className="fp-modal-cancel" onClick={onClose}>
                    Cancel
                </button>
            </div>
        </div>
    );
}


function NgoAuth({ onClose }) {
    const navigate = useNavigate();
    const [isLogin, setIsLogin] = useState(true);
    const [showForgotModal, setShowForgotModal] = useState(false);

    const toggleMode = () => setIsLogin(!isLogin);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLogin) {
            alert("Login Successful! Welcome to Student Support Hub.");
            onClose?.();
            navigate("/ngo/dashboard");
        } else {
            alert("Registration Successful! Please Login.");
            setIsLogin(true);
        }
    };

    return (
        <>
            {showForgotModal && (
                <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
            )}

            <div className="ngo-auth-wrapper">
                <div className="ngo-auth-card">

                    <div className="ngo-auth-left-panel">
                        <div className="ngo-auth-overlay">
                            <div className="ngo-auth-brand-content">
                                <h1>Student Support Hub</h1>
                                <p>Empowering your educational journey with resources and guidance.</p>
                            </div>
                        </div>
                    </div>

                    <div className="ngo-auth-right-panel ngo-auth-fade-in">
                        {isLogin ? (
                            <div>
                                <div className="ngo-auth-form-header">
                                    <h2>Welcome Back!</h2>
                                    <p className="ngo-auth-subtitle">Please login to your account</p>
                                </div>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control type="email" placeholder="name@example.com" required />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" placeholder="Enter your password" required />
                                    </Form.Group>

                                    <div className="text-end mb-3">
                                        <span
                                            style={{ fontSize: '0.9rem', color: '#4361ee', cursor: 'pointer' }}
                                            onClick={() => setShowForgotModal(true)}
                                        >
                                            Forgot Password?
                                        </span>
                                    </div>

                                    <Button type="submit" className="w-100 ngo-auth-btn-primary">
                                        Sign In
                                    </Button>
                                </Form>
                                <div className="ngo-auth-switch-text">
                                    Don't have an account? <a onClick={toggleMode}>Register here</a>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="ngo-auth-form-header">
                                    <h2>Create Account</h2>
                                    <p className="ngo-auth-subtitle">Join Student Support Hub today</p>
                                </div>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Full Name</Form.Label>
                                        <Form.Control type="text" placeholder="John Doe" required />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control type="email" placeholder="name@example.com" required />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" placeholder="Create a password" required />
                                    </Form.Group>

                                    <Button type="submit" className="w-100 ngo-auth-btn-primary">
                                        Sign Up
                                    </Button>
                                </Form>
                                <div className="ngo-auth-switch-text">
                                    Already have an account? <a onClick={toggleMode}>Login here</a>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    );
}

export default NgoAuth;